@import "@stylesheets/variables.scss";

.lead-type-pill {
  display: flex;
  align-items: flex-start;
  padding: 1px 13px 2px 13px;
  border-radius: 18px;
  background-color: $light-blue;
  width: fit-content;
  color: $rea-dark-blue;

  &.exclusive {
    background-color: $exclusive-yellow;
  }
}
